import { useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";
import { PageTitle, Card, inputCls, StatusBadge } from "./ui";
import { toast } from "sonner";
import { Reply, ChevronDown } from "lucide-react";

const TYPES = ["all", "contact", "consultation", "growth-coaching", "youtube-setup", "video-editing", "community-telegram", "community-whatsapp"];
const STATUS_OPTIONS = ["New", "Approved", "Link Sent", "Replied", "Declined"];

export default function Enquiries() {
  const [items, setItems] = useState([]);
  const [type, setType] = useState("all");
  const [openId, setOpenId] = useState(null);

  const load = useCallback(async () => {
    const { data } = await api.get("/admin/enquiries", { params: { type } });
    setItems(data);
  }, [type]);
  useEffect(() => { load(); }, [load]);

  const setStatus = async (id, status) => {
    await api.put(`/admin/enquiries/${id}/status`, { status });
    toast.success("Updated"); load();
  };

  return (
    <>
      <PageTitle title="Enquiries & Messages" subtitle={`${items.length} total`}
        right={<select value={type} onChange={(e) => setType(e.target.value)} className={`${inputCls} sm:w-56`} data-testid="enquiries-filter">
          {TYPES.map((t) => <option key={t} value={t}>{t === "all" ? "All types" : t}</option>)}
        </select>} />

      <div className="space-y-3">
        {items.map((e) => (
          <Card key={e.id} data-testid={`enquiry-${e.id}`}>
            <div className="flex items-start justify-between gap-3 cursor-pointer" onClick={() => setOpenId(openId === e.id ? null : e.id)}>
              <div className="min-w-0">
                <div className="flex items-center gap-2 flex-wrap">
                  <span className="text-[10px] uppercase tracking-widest text-[#D4AF37] bg-[#D4AF37]/10 px-2 py-0.5 rounded">{e.type}</span>
                  <StatusBadge status={e.status} />
                </div>
                <div className="mt-2 font-medium">{e.name} <span className="text-white/40 text-sm">· {e.email}</span></div>
                <div className="text-xs text-white/40">{e.created_at ? new Date(e.created_at).toLocaleString("en-GB") : ""}</div>
              </div>
              <ChevronDown className={`text-white/40 transition-transform ${openId === e.id ? "rotate-180" : ""}`} size={18} />
            </div>
            {openId === e.id && (
              <div className="mt-4 pt-4 border-t border-white/10">
                <dl className="grid sm:grid-cols-2 gap-x-6 gap-y-2 text-sm">
                  {e.whatsapp && <div><dt className="text-white/45 text-xs uppercase">WhatsApp</dt><dd>{e.whatsapp}</dd></div>}
                  {Object.entries(e.data || {}).map(([k, v]) => (
                    <div key={k} className={k.toLowerCase().includes("message") || k.toLowerCase().includes("notes") ? "sm:col-span-2" : ""}>
                      <dt className="text-white/45 text-xs uppercase">{k}</dt><dd className="text-white/85 whitespace-pre-wrap">{String(v) || "—"}</dd>
                    </div>
                  ))}
                </dl>
                <div className="mt-4 flex flex-wrap items-center gap-3">
                  <a href={`mailto:${e.email}`} className="inline-flex items-center gap-2 rounded-lg bg-gradient-to-r from-[#D4AF37] to-[#F0D77B] px-4 py-2 text-sm font-medium text-[#0A0A0A]"><Reply size={15} /> Reply by email</a>
                  <select value={e.status} onChange={(ev) => setStatus(e.id, ev.target.value)} className={`${inputCls} w-48`} data-testid={`enquiry-status-${e.id}`}>
                    {STATUS_OPTIONS.map((s) => <option key={s} value={s}>{s}</option>)}
                  </select>
                </div>
              </div>
            )}
          </Card>
        ))}
        {items.length === 0 && <div className="text-center text-white/30 py-12">No enquiries yet.</div>}
      </div>
    </>
  );
}
